import {
  GET_SCENARIO_VARIABLES_SUCCESS,
  CREATE_SCENARIO_VARIABLE_SUCCESS,
  CREATE_SCENARIO_VARIABLE_FAILURE,
  DELETE_SCENARIO_VARIABLE_SUCCESS,
  DELETE_SCENARIO_VARIABLE_FAILURE,
  UPDATE_SCENARIO_VARIABLE_SUCCESS,
  UPDATE_SCENARIO_VARIABLE_FAILURE,
  SEARCH_SCENARIO_VARIABLES
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'
let cacheItems = null

export const scenarioVariables = (state = {}, action) => {
  switch (action.type) {
    case GET_SCENARIO_VARIABLES_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioVariables.GET_SCENARIO_VARIABLES_SUCCESS()', {
        state,
        action
      })
      return {
        ...state,
        items: action.data
      }
    }
    case CREATE_SCENARIO_VARIABLE_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioVariables.CREATE_SCENARIO_VARIABLE_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }
    case CREATE_SCENARIO_VARIABLE_FAILURE: {
      return { ...state, error: action.data }
    }
    case UPDATE_SCENARIO_VARIABLE_SUCCESS: {
      const newItems = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioVariables.UPDATE_SCENARIO_VARIABLE_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }
    case UPDATE_SCENARIO_VARIABLE_FAILURE: {
      return { ...state, error: action.data }
    }
    case DELETE_SCENARIO_VARIABLE_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioVariables.DELETE_SCENARIO_VARIABLE_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }
    case DELETE_SCENARIO_VARIABLE_FAILURE: {
      return { ...state, error: action.data }
    }
    case SEARCH_SCENARIO_VARIABLES: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }
    default:
      return state
  }
}
